import styled from "@emotion/styled";
import { TextField } from "@mui/material";
import {
  Office,
  Search,
  Text,
} from "@totalenergiescode/mobility-business-rev-design-system";

export const StyledDrawerContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledDrawerHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 16px;

  @media (min-width: 760px) {
    gap: 24px;
    padding: 48px 40px 24px 40px;
  }
`;

export const StyledDrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  flex: 1;

  @media (min-width: 760px) {
    gap: 40px;
    padding: 40px;
  }
`;

export const StyledButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: 760px) {
    flex-direction: row;
    justify-content: center;
    gap: 16px;
  }
`;

export const StyledSearchField = styled(TextField)`
  width: 100%;
  border-radius: 50px 50px 0px 50px;

  .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) => theme.palette.grey[200]};
    border-radius: 50px 50px 0px 50px;
    border-width: 1px;
  }

  &:focus-within .MuiOutlinedInput-notchedOutline {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }

  .MuiOutlinedInput-root {
    min-height: 40px;
    height: 40px;
    box-sizing: border-box;
    padding-left: 8px;
    align-items: center;
    background-color: ${({ theme }) => theme.palette.white};
    border-radius: 50px 50px 0px 50px;
  }

  .MuiInputBase-input {
    padding: 8px 12px 8px 0;
    height: auto;
    box-sizing: border-box;
  }

  .MuiInputAdornment-root > div {
    padding: 4px;
  }
`;

export const StyledSearchIcon = styled(Search)`
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const StyledOptionContainer = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 8px 24px;
  cursor: pointer;
  &:hover,
  &.Mui-focused,
  &[aria-selected="true"] {
    background-color: ${({ theme }) => theme.palette.grey[100]};
  }
`;

export const StyledOptionLeftContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1;
`;

export const StyledOfficeIcon = styled(Office)`
  color: ${({ theme }) => theme.palette.white};
  padding: 0 8px;
  background-color: ${({ theme }) => theme.palette.info.main};
  border-radius: 80px;
  flex-shrink: 0;
`;

export const StyledOptionText = styled(Text, {
  shouldForwardProp: (prop) => prop !== "$displayOnly",
})<{ $displayOnly?: boolean }>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  strong {
    font-weight: 700;
  }
  ${({ $displayOnly }) =>
    $displayOnly &&
    `
    opacity: 0.6;
    pointer-events: none;
    user-select: none;
    margin-right: 8px;
  `}
`;
